<div class="d-flex date-time-picker">
    <input class="bg-default shadow pl-2 grey-border"
    placeholder="Please Select" readonly
    ngbDatepicker #d="ngbDatepicker" [minDate]="minDate"
    (click)="d.toggle()" [(ngModel)]="date" (ngModelChange)="onChangeValue()">
    <ngb-timepicker [(ngModel)]="time" [meridian]="true" [spinners]="true" (ngModelChange)="onChangeValue()"></ngb-timepicker>
</div>